/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * AutoGPT Agent Server
 * This server is used to execute agents that are created by the AutoGPT system.
 * OpenAPI spec version: 0.1
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type { HTTP401NotAuthenticatedErrorResponse } from "../../models/hTTP401NotAuthenticatedErrorResponse.ts";

import type { HTTPValidationError } from "../../models/hTTPValidationError.ts";

import type { NotificationPreference } from "../../models/notificationPreference.ts";

import type { NotificationPreferenceDTO } from "../../models/notificationPreferenceDTO.ts";

import type { PostV1ApplyAVolumeKnobChoiceFromABriefingFooterLinkParams } from "../../models/postV1ApplyAVolumeKnobChoiceFromABriefingFooterLinkParams.ts";

import type { RecordUserConsentRequest } from "../../models/recordUserConsentRequest.ts";

import type { TimezoneResponse } from "../../models/timezoneResponse.ts";

import type { UpdateTimezoneRequest } from "../../models/updateTimezoneRequest.ts";

import type { UserConsentResponse } from "../../models/userConsentResponse.ts";

import { customMutator } from "../../../mutators/custom-mutator.ts";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K,
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type postV1GetOrCreateUserResponse200 = {
  data: unknown;
  status: 200;
};

export type postV1GetOrCreateUserResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type postV1GetOrCreateUserResponseSuccess =
  postV1GetOrCreateUserResponse200 & {
    headers: Headers;
  };
export type postV1GetOrCreateUserResponseError =
  postV1GetOrCreateUserResponse401 & {
    headers: Headers;
  };

export type postV1GetOrCreateUserResponse =
  | postV1GetOrCreateUserResponseSuccess
  | postV1GetOrCreateUserResponseError;

export const getPostV1GetOrCreateUserUrl = () => {
  return `/api/auth/user`;
};

/**
 * @summary Get or create user
 */
export const postV1GetOrCreateUser = async (
  options?: RequestInit,
): Promise<postV1GetOrCreateUserResponse> => {
  return customMutator<postV1GetOrCreateUserResponse>(
    getPostV1GetOrCreateUserUrl(),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getPostV1GetOrCreateUserMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV1GetOrCreateUser>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV1GetOrCreateUser>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postV1GetOrCreateUser"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV1GetOrCreateUser>>,
    void
  > = () => {
    return postV1GetOrCreateUser(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV1GetOrCreateUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV1GetOrCreateUser>>
>;

export type PostV1GetOrCreateUserMutationError =
  HTTP401NotAuthenticatedErrorResponse;

/**
 * @summary Get or create user
 */
export const usePostV1GetOrCreateUser = <
  TError = HTTP401NotAuthenticatedErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV1GetOrCreateUser>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV1GetOrCreateUser>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostV1GetOrCreateUserMutationOptions(options),
    queryClient,
  );
};
export type postV1RecordUserConsentResponse200 = {
  data: UserConsentResponse;
  status: 200;
};

export type postV1RecordUserConsentResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type postV1RecordUserConsentResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type postV1RecordUserConsentResponseSuccess =
  postV1RecordUserConsentResponse200 & {
    headers: Headers;
  };
export type postV1RecordUserConsentResponseError = (
  | postV1RecordUserConsentResponse401
  | postV1RecordUserConsentResponse422
) & {
  headers: Headers;
};

export type postV1RecordUserConsentResponse =
  | postV1RecordUserConsentResponseSuccess
  | postV1RecordUserConsentResponseError;

export const getPostV1RecordUserConsentUrl = () => {
  return `/api/auth/user/consent`;
};

/**
 * Record the terms version accepted at signup and, if the user refused
 * marketing email, the opt-out. Idempotent; never clears an opt-out.
 * @summary Record user consent
 */
export const postV1RecordUserConsent = async (
  recordUserConsentRequest: RecordUserConsentRequest,
  options?: RequestInit,
): Promise<postV1RecordUserConsentResponse> => {
  return customMutator<postV1RecordUserConsentResponse>(
    getPostV1RecordUserConsentUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(recordUserConsentRequest),
    },
  );
};

export const getPostV1RecordUserConsentMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV1RecordUserConsent>>,
    TError,
    { data: RecordUserConsentRequest },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV1RecordUserConsent>>,
  TError,
  { data: RecordUserConsentRequest },
  TContext
> => {
  const mutationKey = ["postV1RecordUserConsent"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV1RecordUserConsent>>,
    { data: RecordUserConsentRequest }
  > = (props) => {
    const { data } = props ?? {};

    return postV1RecordUserConsent(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV1RecordUserConsentMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV1RecordUserConsent>>
>;
export type PostV1RecordUserConsentMutationBody = RecordUserConsentRequest;
export type PostV1RecordUserConsentMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

/**
 * @summary Record user consent
 */
export const usePostV1RecordUserConsent = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV1RecordUserConsent>>,
      TError,
      { data: RecordUserConsentRequest },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV1RecordUserConsent>>,
  TError,
  { data: RecordUserConsentRequest },
  TContext
> => {
  return useMutation(
    getPostV1RecordUserConsentMutationOptions(options),
    queryClient,
  );
};
export type getV1GetNotificationPreferencesResponse200 = {
  data: NotificationPreference;
  status: 200;
};

export type getV1GetNotificationPreferencesResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV1GetNotificationPreferencesResponseSuccess =
  getV1GetNotificationPreferencesResponse200 & {
    headers: Headers;
  };
export type getV1GetNotificationPreferencesResponseError =
  getV1GetNotificationPreferencesResponse401 & {
    headers: Headers;
  };

export type getV1GetNotificationPreferencesResponse =
  | getV1GetNotificationPreferencesResponseSuccess
  | getV1GetNotificationPreferencesResponseError;

export const getGetV1GetNotificationPreferencesUrl = () => {
  return `/api/auth/user/preferences`;
};

/**
 * @summary Get notification preferences
 */
export const getV1GetNotificationPreferences = async (
  options?: RequestInit,
): Promise<getV1GetNotificationPreferencesResponse> => {
  return customMutator<getV1GetNotificationPreferencesResponse>(
    getGetV1GetNotificationPreferencesUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV1GetNotificationPreferencesQueryKey = () => {
  return [`/api/auth/user/preferences`] as const;
};

export const getGetV1GetNotificationPreferencesQueryOptions = <
  TData = Awaited<ReturnType<typeof getV1GetNotificationPreferences>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getV1GetNotificationPreferences>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetV1GetNotificationPreferencesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV1GetNotificationPreferences>>
  > = ({ signal }) =>
    getV1GetNotificationPreferences({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV1GetNotificationPreferences>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV1GetNotificationPreferencesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV1GetNotificationPreferences>>
>;
export type GetV1GetNotificationPreferencesQueryError =
  HTTP401NotAuthenticatedErrorResponse;

export function useGetV1GetNotificationPreferences<
  TData = Awaited<ReturnType<typeof getV1GetNotificationPreferences>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1GetNotificationPreferences>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1GetNotificationPreferences>>,
          TError,
          Awaited<ReturnType<typeof getV1GetNotificationPreferences>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1GetNotificationPreferences<
  TData = Awaited<ReturnType<typeof getV1GetNotificationPreferences>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1GetNotificationPreferences>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1GetNotificationPreferences>>,
          TError,
          Awaited<ReturnType<typeof getV1GetNotificationPreferences>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1GetNotificationPreferences<
  TData = Awaited<ReturnType<typeof getV1GetNotificationPreferences>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1GetNotificationPreferences>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get notification preferences
 */

export function useGetV1GetNotificationPreferences<
  TData = Awaited<ReturnType<typeof getV1GetNotificationPreferences>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1GetNotificationPreferences>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV1GetNotificationPreferencesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get notification preferences
 */
export const prefetchGetV1GetNotificationPreferencesQuery = async <
  TData = Awaited<ReturnType<typeof getV1GetNotificationPreferences>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  queryClient: QueryClient,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1GetNotificationPreferences>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV1GetNotificationPreferencesQueryOptions(options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type postV1UpdateNotificationPreferencesResponse200 = {
  data: NotificationPreference;
  status: 200;
};

export type postV1UpdateNotificationPreferencesResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type postV1UpdateNotificationPreferencesResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type postV1UpdateNotificationPreferencesResponseSuccess =
  postV1UpdateNotificationPreferencesResponse200 & {
    headers: Headers;
  };
export type postV1UpdateNotificationPreferencesResponseError = (
  | postV1UpdateNotificationPreferencesResponse401
  | postV1UpdateNotificationPreferencesResponse422
) & {
  headers: Headers;
};

export type postV1UpdateNotificationPreferencesResponse =
  | postV1UpdateNotificationPreferencesResponseSuccess
  | postV1UpdateNotificationPreferencesResponseError;

export const getPostV1UpdateNotificationPreferencesUrl = () => {
  return `/api/auth/user/preferences`;
};

/**
 * @summary Update notification preferences
 */
export const postV1UpdateNotificationPreferences = async (
  notificationPreferenceDTO: NotificationPreferenceDTO,
  options?: RequestInit,
): Promise<postV1UpdateNotificationPreferencesResponse> => {
  return customMutator<postV1UpdateNotificationPreferencesResponse>(
    getPostV1UpdateNotificationPreferencesUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(notificationPreferenceDTO),
    },
  );
};

export const getPostV1UpdateNotificationPreferencesMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV1UpdateNotificationPreferences>>,
    TError,
    { data: NotificationPreferenceDTO },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV1UpdateNotificationPreferences>>,
  TError,
  { data: NotificationPreferenceDTO },
  TContext
> => {
  const mutationKey = ["postV1UpdateNotificationPreferences"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV1UpdateNotificationPreferences>>,
    { data: NotificationPreferenceDTO }
  > = (props) => {
    const { data } = props ?? {};

    return postV1UpdateNotificationPreferences(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV1UpdateNotificationPreferencesMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV1UpdateNotificationPreferences>>
>;
export type PostV1UpdateNotificationPreferencesMutationBody =
  NotificationPreferenceDTO;
export type PostV1UpdateNotificationPreferencesMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

/**
 * @summary Update notification preferences
 */
export const usePostV1UpdateNotificationPreferences = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV1UpdateNotificationPreferences>>,
      TError,
      { data: NotificationPreferenceDTO },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV1UpdateNotificationPreferences>>,
  TError,
  { data: NotificationPreferenceDTO },
  TContext
> => {
  return useMutation(
    getPostV1UpdateNotificationPreferencesMutationOptions(options),
    queryClient,
  );
};
export type postV1ApplyAVolumeKnobChoiceFromABriefingFooterLinkResponse200 = {
  data: NotificationPreference;
  status: 200;
};

export type postV1ApplyAVolumeKnobChoiceFromABriefingFooterLinkResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type postV1ApplyAVolumeKnobChoiceFromABriefingFooterLinkResponseSuccess =
  postV1ApplyAVolumeKnobChoiceFromABriefingFooterLinkResponse200 & {
    headers: Headers;
  };
export type postV1ApplyAVolumeKnobChoiceFromABriefingFooterLinkResponseError =
  postV1ApplyAVolumeKnobChoiceFromABriefingFooterLinkResponse422 & {
    headers: Headers;
  };

export type postV1ApplyAVolumeKnobChoiceFromABriefingFooterLinkResponse =
  | postV1ApplyAVolumeKnobChoiceFromABriefingFooterLinkResponseSuccess
  | postV1ApplyAVolumeKnobChoiceFromABriefingFooterLinkResponseError;

export const getPostV1ApplyAVolumeKnobChoiceFromABriefingFooterLinkUrl = (
  params: PostV1ApplyAVolumeKnobChoiceFromABriefingFooterLinkParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/auth/user/preferences/from-email?${stringifiedParams}`
    : `/api/auth/user/preferences/from-email`;
};

/**
 * Apply one footer choice, authorised by the token in the link.
 *
 * Deliberately not `Security(requires_user)`. The session is the wrong
 * authority here: the settings page applies this on arrival, so a
 * session-authenticated write would let any third party change a logged-in
 * reader's preferences just by getting them to follow a link. The HMAC binds
 * the choice to the recipient we sent it to, exactly as the unsubscribe link
 * does, and works whether or not they happen to be signed in.
 * @summary Apply a volume-knob choice from a Briefing footer link
 */
export const postV1ApplyAVolumeKnobChoiceFromABriefingFooterLink = async (
  params: PostV1ApplyAVolumeKnobChoiceFromABriefingFooterLinkParams,
  options?: RequestInit,
): Promise<postV1ApplyAVolumeKnobChoiceFromABriefingFooterLinkResponse> => {
  return customMutator<postV1ApplyAVolumeKnobChoiceFromABriefingFooterLinkResponse>(
    getPostV1ApplyAVolumeKnobChoiceFromABriefingFooterLinkUrl(params),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getPostV1ApplyAVolumeKnobChoiceFromABriefingFooterLinkMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postV1ApplyAVolumeKnobChoiceFromABriefingFooterLink>
      >,
      TError,
      { params: PostV1ApplyAVolumeKnobChoiceFromABriefingFooterLinkParams },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof postV1ApplyAVolumeKnobChoiceFromABriefingFooterLink>
    >,
    TError,
    { params: PostV1ApplyAVolumeKnobChoiceFromABriefingFooterLinkParams },
    TContext
  > => {
    const mutationKey = ["postV1ApplyAVolumeKnobChoiceFromABriefingFooterLink"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postV1ApplyAVolumeKnobChoiceFromABriefingFooterLink>
      >,
      { params: PostV1ApplyAVolumeKnobChoiceFromABriefingFooterLinkParams }
    > = (props) => {
      const { params } = props ?? {};

      return postV1ApplyAVolumeKnobChoiceFromABriefingFooterLink(
        params,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostV1ApplyAVolumeKnobChoiceFromABriefingFooterLinkMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof postV1ApplyAVolumeKnobChoiceFromABriefingFooterLink>
    >
  >;

export type PostV1ApplyAVolumeKnobChoiceFromABriefingFooterLinkMutationError =
  HTTPValidationError;

/**
 * @summary Apply a volume-knob choice from a Briefing footer link
 */
export const usePostV1ApplyAVolumeKnobChoiceFromABriefingFooterLink = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postV1ApplyAVolumeKnobChoiceFromABriefingFooterLink>
      >,
      TError,
      { params: PostV1ApplyAVolumeKnobChoiceFromABriefingFooterLinkParams },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<
    ReturnType<typeof postV1ApplyAVolumeKnobChoiceFromABriefingFooterLink>
  >,
  TError,
  { params: PostV1ApplyAVolumeKnobChoiceFromABriefingFooterLinkParams },
  TContext
> => {
  return useMutation(
    getPostV1ApplyAVolumeKnobChoiceFromABriefingFooterLinkMutationOptions(
      options,
    ),
    queryClient,
  );
};
export type getV1GetUserTimezoneResponse200 = {
  data: TimezoneResponse;
  status: 200;
};

export type getV1GetUserTimezoneResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV1GetUserTimezoneResponseSuccess =
  getV1GetUserTimezoneResponse200 & {
    headers: Headers;
  };
export type getV1GetUserTimezoneResponseError =
  getV1GetUserTimezoneResponse401 & {
    headers: Headers;
  };

export type getV1GetUserTimezoneResponse =
  | getV1GetUserTimezoneResponseSuccess
  | getV1GetUserTimezoneResponseError;

export const getGetV1GetUserTimezoneUrl = () => {
  return `/api/auth/user/timezone`;
};

/**
 * Get user timezone setting.
 * @summary Get user timezone
 */
export const getV1GetUserTimezone = async (
  options?: RequestInit,
): Promise<getV1GetUserTimezoneResponse> => {
  return customMutator<getV1GetUserTimezoneResponse>(
    getGetV1GetUserTimezoneUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV1GetUserTimezoneQueryKey = () => {
  return [`/api/auth/user/timezone`] as const;
};

export const getGetV1GetUserTimezoneQueryOptions = <
  TData = Awaited<ReturnType<typeof getV1GetUserTimezone>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getV1GetUserTimezone>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetV1GetUserTimezoneQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV1GetUserTimezone>>
  > = ({ signal }) => getV1GetUserTimezone({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV1GetUserTimezone>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV1GetUserTimezoneQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV1GetUserTimezone>>
>;
export type GetV1GetUserTimezoneQueryError =
  HTTP401NotAuthenticatedErrorResponse;

export function useGetV1GetUserTimezone<
  TData = Awaited<ReturnType<typeof getV1GetUserTimezone>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1GetUserTimezone>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1GetUserTimezone>>,
          TError,
          Awaited<ReturnType<typeof getV1GetUserTimezone>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1GetUserTimezone<
  TData = Awaited<ReturnType<typeof getV1GetUserTimezone>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1GetUserTimezone>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1GetUserTimezone>>,
          TError,
          Awaited<ReturnType<typeof getV1GetUserTimezone>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1GetUserTimezone<
  TData = Awaited<ReturnType<typeof getV1GetUserTimezone>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1GetUserTimezone>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get user timezone
 */

export function useGetV1GetUserTimezone<
  TData = Awaited<ReturnType<typeof getV1GetUserTimezone>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1GetUserTimezone>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV1GetUserTimezoneQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get user timezone
 */
export const prefetchGetV1GetUserTimezoneQuery = async <
  TData = Awaited<ReturnType<typeof getV1GetUserTimezone>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  queryClient: QueryClient,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1GetUserTimezone>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV1GetUserTimezoneQueryOptions(options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type postV1UpdateUserTimezoneResponse200 = {
  data: TimezoneResponse;
  status: 200;
};

export type postV1UpdateUserTimezoneResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type postV1UpdateUserTimezoneResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type postV1UpdateUserTimezoneResponseSuccess =
  postV1UpdateUserTimezoneResponse200 & {
    headers: Headers;
  };
export type postV1UpdateUserTimezoneResponseError = (
  | postV1UpdateUserTimezoneResponse401
  | postV1UpdateUserTimezoneResponse422
) & {
  headers: Headers;
};

export type postV1UpdateUserTimezoneResponse =
  | postV1UpdateUserTimezoneResponseSuccess
  | postV1UpdateUserTimezoneResponseError;

export const getPostV1UpdateUserTimezoneUrl = () => {
  return `/api/auth/user/timezone`;
};

/**
 * Update user timezone. The timezone should be a valid IANA timezone identifier.
 * @summary Update user timezone
 */
export const postV1UpdateUserTimezone = async (
  updateTimezoneRequest: UpdateTimezoneRequest,
  options?: RequestInit,
): Promise<postV1UpdateUserTimezoneResponse> => {
  return customMutator<postV1UpdateUserTimezoneResponse>(
    getPostV1UpdateUserTimezoneUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(updateTimezoneRequest),
    },
  );
};

export const getPostV1UpdateUserTimezoneMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV1UpdateUserTimezone>>,
    TError,
    { data: UpdateTimezoneRequest },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV1UpdateUserTimezone>>,
  TError,
  { data: UpdateTimezoneRequest },
  TContext
> => {
  const mutationKey = ["postV1UpdateUserTimezone"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV1UpdateUserTimezone>>,
    { data: UpdateTimezoneRequest }
  > = (props) => {
    const { data } = props ?? {};

    return postV1UpdateUserTimezone(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV1UpdateUserTimezoneMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV1UpdateUserTimezone>>
>;
export type PostV1UpdateUserTimezoneMutationBody = UpdateTimezoneRequest;
export type PostV1UpdateUserTimezoneMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

/**
 * @summary Update user timezone
 */
export const usePostV1UpdateUserTimezone = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV1UpdateUserTimezone>>,
      TError,
      { data: UpdateTimezoneRequest },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV1UpdateUserTimezone>>,
  TError,
  { data: UpdateTimezoneRequest },
  TContext
> => {
  return useMutation(
    getPostV1UpdateUserTimezoneMutationOptions(options),
    queryClient,
  );
};
